import { IModalProps } from '../../../../common';
import { ReactComponent as Image } from '../../../../../assets/images/cv/a-gradient.svg';

import { CvModalBase } from '../cv-modal-base';
import { useStyles } from './cv-callback-request-success.styles';
import { v2026PP10366 } from '../../../../../constants/veeva';

export const CvCallbackRequestSuccess = (props: IModalProps): JSX.Element => {
  const classes = useStyles();

  return (
    <CvModalBase
      {...props}
      image={<Image aria-hidden="true" className={classes.large} />}
      text="common.success"
      veevaNumber={v2026PP10366}
    />
  );
};
